import { z } from 'zod';

import {
  AgeStatusSchema,
  HttpUrlSchema,
  LivingStatusSchema,
  NonEmptyStringSchema,
  QidSchema,
} from './primitives.js';

export const SelectionSignalsSchema = z.object({
  shortWindowAttention: z.number().finite().nonnegative(),
  longWindowAttention: z.number().finite().nonnegative(),
  sitelinkCount: z.number().int().nonnegative(),
  hasPublicRole: z.boolean(),
  approvedConnectivity: z.number().int().nonnegative(),
  evergreen: z.boolean(),
  domainAdjustment: z.number().finite(),
});

export type SelectionSignals = z.infer<typeof SelectionSignalsSchema>;

export const InclusionRoleSchema = z.enum(['baseline', 'connector', 'context']);

export type InclusionRole = z.infer<typeof InclusionRoleSchema>;

export const PersonSchema = z.object({
  id: QidSchema,
  name: NonEmptyStringSchema,
  aliases: z.array(NonEmptyStringSchema),
  description: NonEmptyStringSchema.optional(),
  wikipediaUrl: HttpUrlSchema.optional(),
  livingStatus: LivingStatusSchema,
  ageStatus: AgeStatusSchema,
  birthYear: z.number().int().optional(),
  deathYear: z.number().int().optional(),
  domains: z.array(NonEmptyStringSchema),
  recognitionScore: z.number().finite().nonnegative(),
  selectionSignals: SelectionSignalsSchema,
  inclusionRole: InclusionRoleSchema.default('baseline'),
  featured: z.boolean().optional(),
});

export type Person = z.infer<typeof PersonSchema>;
